import { ReactNode } from 'react'

interface KeyValueItem {
  label: string
  value: ReactNode
  className?: string
  span?: 1 | 2
}

interface KeyValueDisplayProps {
  items: KeyValueItem[]
  className?: string
}

const KeyValueDisplay = ({ items, className = '' }: KeyValueDisplayProps) => {
  return (
    <dl className={`grid grid-cols-2 gap-4 text-sm ${className}`}>
      {items.map((item, index) => (
        <div key={index} className={item.span === 2 ? 'col-span-2' : ''}>
          <dt className="text-xs font-semibold uppercase tracking-wide opacity-60">
            {item.label}
          </dt>
          <dd className={item.className || 'break-all'}>{item.value}</dd>
        </div>
      ))}
    </dl>
  )
}

export type { KeyValueItem }
export { KeyValueDisplay }
